namespace Solovis.Time {

    /**
     * Given a local date/time return a date that represents the UTC time
     * (ignoring the fact that Javascript considers all dates to be local dates)
     * @param date
     */
    export function getUtcDateFromLocalDate(date: Date): Date {     
        if (!date) {
            return null;
        }

        var utcDate = new Date(date.getUTCFullYear(),
            date.getUTCMonth(),
            date.getUTCDate(),
            date.getUTCHours(),
            date.getUTCMinutes(),
            date.getUTCSeconds(),
            date.getUTCMilliseconds());

        return utcDate;
    };
    
    /**
     * Treat date parameter as a UTC date/time (ignoring the fact that Javascript considers all dates to be local dates)
     * and return the local date/time.
     * @param date
     */
    export function getLocalDateFromUtcDate(date: Date): Date {
        if (!date) {
            return null;
        }

        var offset = date.getTimezoneOffset();
        var newDate = new Date(date.getTime() - (offset * 60 * 1000));

        return newDate;
    }

}
